

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { PrinterSettingsDS } from './printersettingsds';
import { Guid } from 'guid-typescript';



export interface PrinterSettingsParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface PrinterSettings {
  id:any,
  pageSetupFor:any,
  paperSize:any,
  orientation:any,
  topMargin:any,
  bottomMargin:any,
  leftMargin:any,
  rightMargin:any,
  height:any,
  width:any,
  topHeaderRequired:any,
  topHeaderLine1:any,
  topHeaderLine2:any,
  topHeaderLine3:any,
  topHeaderLine4:any,
  topHeaderLogoRequired:any,
  headerlogoName?: any;
  topHeaderLogoPosition:any,
  topHeaderPosition:any,
  bottomFooterRequired:any,
  bottomFooterLine1:any,
  bottomFooterLine2:any, 
  bottomFooterLine3:any,
  bottomFooterLine4:any,
  bottomFooterLogoRequired:any,
  bottomFooterLogoPosition:any,
  bottomFooterPosition:any,
  reportHeader:any,
  reportFooter:any,
  digitalSignatureLocation:any,
  digitalSignatureLocation1?:string,
  templateName:any,
  reportHeaderPlacement:any;
  reportFooterPlacement:any;  
  pageTitle:any;
  tableTitle:any;
  othersettings:any;
  regBarcodeId:any;
  topHeaderlogoCategory?:string;
  topHeader_2_logoRequired?:string;
  topHeader_2_logoCategory?:string;
  topheader_2_logoPosition?:string;
  bottomFooterlogoCategory?:string;
  bottomFooter_2_logoRequired?:string;
  bottomFooter_2_logoCategory?:string;
  bottomFooter_2_logoPosition?:string;
  tenantId?: string;
  branchId?: string;
  parameters?: PrinterSettingsParameter[];
  links?: any;
  printerSettingsDsMst?:PrinterSettingsDS;
  qrCodeEnableFlag:string,
  qrCodePlacement:string,
  watermarkRequired?:boolean,
  watermarkPosition?: number,
  watermarkText?:string,
  watermarkPositionName?:string,
  watermarkType?:number,
  watermarkImage?:number
}


export interface TypeOptions {
    
    title: string;
  }

export abstract class PrinterSettingsData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<PrinterSettings[]>;
  abstract create(url: string,data: any): Observable<any>;
  abstract update(url: string,data: PrinterSettings): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
